import React from 'react';
import Select from '@components/select';
import * as styles from './CheckSelect.scss';

const CheckSelect = (props) => {
  const {
    values,
    options,
    allGroupTitle,
    handleCheckSelectChange,
    dropdownWidth,
  } = props;

  if (options.length <= 1) {
    return null;
  }

  const valueCheckSelectRenderer = () => {
    const isEmptyFilter = values.length === 0;
    const isFullFilter = values.length === options.length;

    if (isEmptyFilter || isFullFilter) {
      return (
        <div
          role="button"
          className={styles.valueField}
          onClick={() => null}
        >
          {allGroupTitle}
        </div>
      );
    }

    const firstOption = options.find(o => o.value === values[0].value);
    const valuesLength = values.length - 1;
    const text = valuesLength > 0 ? ` +${valuesLength}` : '';

    return (
      <div
        className={styles.valueField}
        role="button"
        onClick={() => null}
      >
        <span>
          { firstOption.text }
        </span>
        <span>
          { text }
        </span>
      </div>
    );
  };

  return (
    <div className={styles.checkSelectContainer}>
      <Select
        isMulti
        name="contact-field"
        options={options}
        multiValue={values}
        onMultiChange={handleCheckSelectChange}
        renderInputValue={valueCheckSelectRenderer}
        hideSelectAllButton
        valueProperty="value"
        labelProperty="text"
        dropdownWidth={dropdownWidth}
      />
    </div>
  );
};

export default CheckSelect;
